<template>
  <project-manager-layout :spinning="isLoading">
    <leader-project-layout :model="model">
      <template #underInfo>
        <div class="leader-project__common-progress" v-if="model.id">
          <progress-bar-generated
            :show-label="true"
            :show-percent="true"
            :completed="model.completedCount"
            :completed-overdue="model.completedOverdueCount"
            :incomplete-overdue="model.incompleteOverdueCount"
            :incomplete="model.incompleteCount"
          />
        </div>
      </template>
      <a-col class="project-indexes" v-if="projectIndexesIsVisible" :span="20">
        <div>
          <h3>Показатели</h3>
          <div class="description"></div>

          <portfolio-indexes-grid
            :disabled="disabled"
            :briefcases="briefcases"
          />
        </div>
      </a-col>
    </leader-project-layout>
  </project-manager-layout>
</template>

<script setup>
  import { computed, onMounted, reactive, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import {
    PROJECT_STATUS_CLOSED,
    PROJECT_STATUS_DRAFT,
  } from '@/api/models/ProjectStatus';
  import ProjectManagerLayout from '@/layouts/ProjectManagerLayout.vue';
  import LeaderProjectLayout from '@/views/leader/projects/components/LeaderProjectLayout.vue';
  import PortfolioIndexesGrid from '@/components/projects/portfolio/components/PorfolioIndexesGrid.vue';
  import ProgressBarGenerated from '@/components/projects/portfolio/components/ProgressBarGenerated.vue';

  const api = useApi();
  const route = useRoute();
  const model = reactive({
    id: null,
    number: '',
    name: '',
    description: '',
    projectType: '',
    requestId: null,
    status: null,
    projectStatusId: null,
    isMyProject: false,
    completedCount: 0,
    completedOverdueCount: 0,
    incompleteOverdueCount: 0,
    incompleteCount: 0,
  });

  const briefcases = ref([]);
  const isLoading = ref(false);
  const projectIndexesIsVisible = computed(
    () => model.projectStatusId !== PROJECT_STATUS_DRAFT
  );
  const disabled = computed(
    () => model.projectStatusId === PROJECT_STATUS_CLOSED
  );

  onMounted(async () => {
    await getModel();
    await getPortfolioIndexes();
    isLoading.value = false;
  });

  const getModel = async () => {
    try {
      const response = await api.leaderPage.view(route.params.id);
      model.id = response.project.id;
      model.name = response.project.name;
      model.number = response.project.id;
      model.type = response.project.type;
      model.requestId = response.project.requestId;
      model.status = response.project.status;
      model.projectStatusId = response.project.projectStatusId;
      model.isMyProject = response.project.isMyProject;
      model.completedCount = response.project.completedCount;
      model.completedOverdueCount = response.project.completedOverdueCount;
      model.incompleteOverdueCount = response.project.incompleteOverdueCount;
      model.incompleteCount = response.project.incompleteCount;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getPortfolioIndexes = async () => {
    try {
      const response = await api.briefcase.projectBriefcaseIndexes(
        new URLSearchParams({
          projectId: route.params.id,
        })
      );
      briefcases.value = response.briefcases;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .leader-project__common-progress {
    margin-top: 42px;
  }

  .ant-input {
    font-family: 'Nunito Sans', sans-serif;

    &[disabled] {
      color: $color-text-primary;
    }
  }

  .project-indexes {
    margin-top: 10px;

    h3 {
      font-size: 18px;
      margin-bottom: 10px;
    }

    h4 {
      font-size: 14px;
      margin: 30px 0 6px;

      &.disabled {
        color: $color-bg-status-new !important;
      }
    }

    .description {
      font-family: 'Nunito Sans', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      max-width: 678px;
    }

    .divider {
      margin: 40px 0 30px;
    }
  }
</style>
